import DOMPurify from 'isomorphic-dompurify'

DOMPurify.setConfig({
  FORBID_TAGS: [
    'form',
    'input',
    'select',
    'option',
    'script',
    'style',
    'iframe',
  ],
})

DOMPurify.addHook('uponSanitizeAttribute', function (
  currentNode,
  hookEvent,
  config
) {
  // Do something with the current node and return it
  // You can also mutate hookEvent (i.e. set hookEvent.forceKeepAttr = true)
  if (/^data\:.+/i.test(`${hookEvent.attrValue}`.trim())) {
    hookEvent.keepAttr = false
  }
  return currentNode
})

// DOMPurify.addHook('afterSanitizeAttributes', (node) => {
//   const { attributes } = node
//   if (!attributes  || attributes.length < 2)
//     return
//   // No need to switch the last one.

//   for (let l = attributes.length - 2; l >= 0; l--) {
//     const attr = attributes[l]
//     const { name, value } = attr
//     node.removeAttribute(name)
//     node.setAttribute(name, value)
//   }
// })

export default DOMPurify
